export const IMPORT_URLS = {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_GRAPHQL_URL: import.meta.env.VITE_GRAPHQL_URL,
  VITE_NETWORK_TEST_URL: import.meta.env.VITE_NETWORK_TEST_URL,
  VITE_SERVICE_URL: import.meta.env.VITE_SERVICE_URL,
};
